import {
  Modal,
  PrimaryButton,
  BasicButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Select,
  SelectItem,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmploymentVerificationRuleset } from "../types/form-values";

type SelectedValues = {
  ninety_days_or_less: string;
  over_ninety_days: string;
};
interface DateVarianceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (selectedValues: SelectedValues, type: string) => void;
  dateVarianceData?: EmploymentVerificationRuleset["date_variance"];
}

export function DateVarianceModal({
  isOpen,
  onClose,
  onSave,
  dateVarianceData,
}: DateVarianceModalProps) {
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = useState<SelectedValues>({
    ninety_days_or_less: dateVarianceData?.ninety_days_or_less || "REVIEW",
    over_ninety_days: dateVarianceData?.over_ninety_days || "REVIEW",
  });

  return (
    <Modal isOpen={isOpen} testID="date-variance-modal">
      <Dialog width="480px">
        <DialogHeader onClose={onClose}>
          {t("Date variance (start/end dates)")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              {t(
                "Set a tolerance for date discrepancies between what the candidate reported and what the employer confirmed."
              )}
            </Text>
            <Select
              label={t("≤ 90 Threshold days")}
              testID="date-variance-outcome-90-days-select"
              selectedKey={selectedValues.ninety_days_or_less}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  ninety_days_or_less: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
            <Select
              label={t("> 90 Threshold days")}
              testID="date-variance-outcome-greater-than-90-days-select"
              selectedKey={selectedValues.over_ninety_days}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  over_ninety_days: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="cancel-button">
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => {
              onSave(selectedValues, "date_variance");
              onClose();
            }}
            testID="save-button"
          >
            {t("Set")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
